import type { FetchProxyPayload, DashboardFetcher, SchemaField } from '../types';

export interface EndpointMeta {
  generatedAt?: string;
  period?: string;
  rowCount?: number;
}

export interface ProxyFetchResult {
  data: unknown;
  schema: { fields: SchemaField[] } | null;
  endpointMeta: EndpointMeta | null;
}

/**
 * Solicita datos de un widget al Proxy del backend.
 * Retorna data + schema (si el endpoint devolvió envelope estándar).
 */
export const fetchWidgetDataProxy = async (
  payload: FetchProxyPayload,
  fetcher: DashboardFetcher
): Promise<ProxyFetchResult> => {
  const response = await fetcher<{
    source: string;
    timestamp: string;
    data: unknown;
    schema?: { fields: SchemaField[] };
    endpointMeta?: EndpointMeta;
  }>('/api/dashboard/proxy/fetch', {
    method: 'POST',
    body: payload,
  });

  // Validación defensiva: el proxy puede devolver estructura inesperada si el backend cambia
  if (response === null || response === undefined || typeof response !== 'object') {
    console.error('[KPI Dashboard] Proxy devolvió respuesta inválida:', response);
    return { data: null, schema: null, endpointMeta: null };
  }

  if ((response as Record<string, unknown>).data === undefined) {
    console.warn('[KPI Dashboard] Proxy response sin campo "data". Widget:', payload.widgetId);
  }

  return {
    data: response.data ?? null,
    schema: response.schema ?? null,
    endpointMeta: response.endpointMeta ?? null,
  };
};

/**
 * Invalida la caché del proxy para un widget.
 * DELETE /api/dashboard/proxy/cache/:widgetId
 */
export const invalidateWidgetCache = async (
  widgetId: string,
  fetcher: DashboardFetcher
): Promise<void> => {
  await fetcher(`/api/dashboard/proxy/cache/${widgetId}`, { method: 'DELETE' });
};
